import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { ModalType, ModalOptions } from '../../../../Modals/redux/types';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { VerificationRequiredActions } from '../../../../publicSession/types';
import HoverComponent from '../../../_partials/HoverComponent/HoverComponent';
import { useSubmitMenuItem } from '../../../hooks/useSubmitMenuItem';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge';
import s from './SubmitMenuItem.scss';

interface Props {
  type: string;
  label: string;
  modalType?: ModalType;
  modalOptions?: ModalOptions;
  imageFileName?: string;
  imageMarginBottom?: number;
  imageMarginLeft?: number;
  link?: string;
  target?: string;
  verificationAction?: VerificationRequiredActions;
  showDaProtect?: boolean;
  className?: string;
  hoverComponentClassName?: string;
  showNewByTitle?: boolean;
  role?: string;
}

const SubmitMenuItem: React.FC<Props> = ({
  className,
  hoverComponentClassName,
  type,
  modalType,
  modalOptions,
  imageFileName,
  imageMarginBottom,
  imageMarginLeft,
  label,
  link,
  target,
  verificationAction,
  showDaProtect,
  showNewByTitle,
  role,
}) => {
  const { t } = useTranslation();

  const { onClick, href, biData } = useSubmitMenuItem({
    modalType,
    link,
    verificationAction,
    type,
    modalOptions,
  });

  return (
    <PlainButtonOrLink
      className={c(className, s['new-container'])}
      href={href}
      target={target}
      tabIndex={0}
      onClick={onClick}
      biData={biData}
      isFakeButton={!onClick}
      role={role}
    >
      {t(label)}
      {showNewByTitle && (
        <BetaBadge
          badgeType="new"
          className={s['new-badge']}
          size="medium"
          variant="green"
        />
      )}
      {imageFileName && (
        <HoverComponent
          imageFileName={imageFileName}
          imageMarginBottom={imageMarginBottom}
          imageMarginLeft={imageMarginLeft}
          title={t(`${label}.title`)}
          context={t(`${label}.context`)}
          className={hoverComponentClassName}
          showDaProtect={showDaProtect}
        />
      )}
    </PlainButtonOrLink>
  );
};
SubmitMenuItem.displayName = 'SubmitMenuItem';

export default SubmitMenuItem;
